import type { AppGroup } from '@openx/types/targeting/inventoryAndContent';
export const APP_GROUP_PATH = 'deal.package.targeting.app_group';
const APP_GROUP_OBJECT = 'appgroup';

export const mapOptionsByPathToAppGroups = (
  optionsByPath: Array<{ id: string; name: string } | null> | undefined
): AppGroup[] => {
  if (!optionsByPath) return [];

  return optionsByPath
    .filter((item): item is NonNullable<typeof item> => item !== null)
    .map(item => ({
      id: item.id,
      name: item.name,
      object: APP_GROUP_OBJECT,
    }));
};
